export default __webpack_public_path__ + "static/media/bucket_list_new_1.eb099647.gif";